import { apiCall } from "../../../_services/apiCall";
import config from "../../../config/config.json";

const ADMIN_API_URL = config.ADMIN_API_URL;

/**
 * @typedef {object} GhgReference
 * @property {number} id
 * @property {string} title
 * @property {string|null} url
 * @property {string|null} note
 * @property {number} [factor_count] factors citing it for any of their values
 * @property {number} [database_count] databases citing it as a whole
 */

/**
 * @typedef {"ef"|"gwp"|"ncv"|"density"} ReferenceTarget
 */

/**
 * Every reference with its usage counts. Silent, because the panel shows its own error.
 *
 * @returns {Promise<{ isSuccess: boolean, data: { data?: GhgReference[], error?: string } } | undefined>}
 */
export const getGhgReferences = () => apiCall(`${ADMIN_API_URL}ghgReferences`, {}, {}, "GET", { silent: true });

/**
 * Creates a reference, or edits reference `id`. Silent, because ReferenceForm shows the outcome.
 *
 * @param {number|null} id
 * @param {{ title: string, url: string, note: string }} values
 */
export const saveGhgReference = (id, values) =>
  id == null
    ? apiCall(`${ADMIN_API_URL}ghgReferences`, {}, values, "POST", { silent: true })
    : apiCall(`${ADMIN_API_URL}ghgReferences/${id}`, {}, values, "PUT", { silent: true });

/** @param {number} id */
export const deleteGhgReference = (id) => apiCall(`${ADMIN_API_URL}ghgReferences/${id}`, {}, {}, "DELETE");

/**
 * Points the chosen values of many factors at one reference, or clears them
 * with `reference_id` null. The factors are `factor_ids`, or every factor the
 * breakdown `filters` match.
 *
 * @param {{ reference_id: number|null, targets: ReferenceTarget[], factor_ids?: number[], filters?: object }} change
 */
export const applyFactorReference = (change) =>
  apiCall(`${ADMIN_API_URL}emissionFactorReferences`, {}, change, "PUT");
